import {styled} from "@mui/system";

const MainMenuLink = styled('a')(() => ({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'var(--gov-color-white)',

    '@media not all and (pointer: coarse)': {
        '&:hover': {
            color: 'var(--gov-color-blue-hover)',
        },
        '&:hover .gov-header__site-name': {
            color: '#fff',
        },
        '&:hover *': {
            color: 'var(--gov-color-white)',
        },
    },

    '&:focus': {
        boxShadow: '0 0 0 2px var(--gov-color-white)',
    },

    '&:visited': {
        color: 'var(--gov-color-blue-hover)',
    },

    '&:visited *': {
        color: 'var(--gov-color-blue-hover)',
    },

    '& > *': {
        color: 'var(--gov-color-white)',
    },
}));

export default MainMenuLink;

